export default __webpack_public_path__ + "static/media/instagram.16a4348d.svg";